import { render } from "./FlowFormQuestion.vue?vue&type=template&id=72d73498&scoped=true"
import script from "./FlowFormQuestion.vue?vue&type=script&lang=js"
export * from "./FlowFormQuestion.vue?vue&type=script&lang=js"

import "./FlowFormQuestion.vue?vue&type=style&index=0&id=72d73498&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72d73498"]])

export default __exports__